import { render, staticRenderFns } from "./SectionLabel.vue?vue&type=template&id=7b666fda&scoped=true&"
import script from "./SectionLabel.vue?vue&type=script&lang=js&"
export * from "./SectionLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b666fda",
  null
  
)

export default component.exports